
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/longevity-protocol/habits/lifestyle",
      function () {
        return require("private-next-pages/tools/longevity-protocol/habits/lifestyle.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/longevity-protocol/habits/lifestyle"])
      });
    }
  